import axios from "axios";
import { type PaymentDataService } from "./IPaymentDataService";

export const paymentDataService: PaymentDataService = {
  async getStateList() {
    const response = await axios.get("/api/payments/states");

    return response.data;
  },
};
